export const CONFIG_PAGE_TYPE_PLP = 'plp';
export const URGENCY_NUDGE_REMOTE_CONFIG = 'urgencyNudge';
export const DEVICE_OS_KEY = 'device_os';
export enum DEVICE_OS_VALUE {
  DESKTOP = 'desktop',
  MOBILE = 'mweb',
}

export const MWEB_VECTOR_SEARCH = {
  EXPERIMENT_ID: 'mweb-vector-search',
  VARIANT_A: 'mweb-vector-search-a',
  VARIANT_B: 'mweb-vector-search-b',
};


export const MWEB_NEW_RANKING = {
  EXPERIMENT_ID: 'mweb-new-user-ranking',
  VARIANT_A: 'sept_popularity_variant1',
  VARIANT_B: 'sept_popularity_variant2',
};

export const MWEB_RELATED_SEARCH = {
  EXPERIMENT_ID: 'mweb-related-search',
  VARIANT_A: 'mweb-related-search-a',
  VARIANT_B: 'mweb-related-search-b',
};
